import { Component, OnInit, Input } from '@angular/core';
import { Tier3Service } from '../../../services/obs/tier3.service';
import { urlEndPoint } from 'src/app/common';
declare var $: any;

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnInit {

  /* enviar el id al componente carousel */
  @Input() idTier1ForSlider: string = '';
  @Input() idEventTypeForSlider: string = '';
  URL: string = urlEndPoint;
  isUploadDir: boolean = false;
  tier3Data: any[] = null;
  bandSlider: boolean = false;

  constructor(private tier3Service: Tier3Service) { }

  ngOnInit() {
    this.getDataForSlider();
    this.loadCarousel();
  }

  loadCarousel() {
    $('.carousel').carousel({});
  }

  getDataForSlider() {
    if (this.idEventTypeForSlider !== '') {
      this.tier3Service.getTier3MostView4SliderA(this.idEventTypeForSlider).subscribe(
        res => {
          this.tier3Service.getRTier3MostView4SliderA(this.idEventTypeForSlider).subscribe(
            resp => {
              this.tier3Data = [].concat(resp, res)
              if (Object.keys(res).length > 0) {
                this.bandSlider = true
              }
              else {
                this.bandSlider = false
              }
            }
          )

        }
      )
    }

    if (this.idTier1ForSlider !== '') {
      this.tier3Service.getTier3MostView4SliderB(this.idTier1ForSlider).subscribe(
        res => {
          this.tier3Service.getRTier3MostView4SliderB(this.idTier1ForSlider).subscribe(
            resp => {
              this.tier3Data = [].concat(resp, res)
              if (Object.keys(res).length > 0) {
                this.bandSlider = true
              }
              else {
                this.bandSlider = false
              }
            }
          )

        }
      )
    }

  }

  verifiedLength(word: string): boolean {
    if (!word) return false;
    return word.length <= 83;
  }

  verifiedImgDirectory(imagen: string): boolean {
    if (!imagen) return false;
    const subcadena = imagen.slice(1, 7);
    return subcadena === 'upload';
  }

}
